// ** Reducers Imports
import layout from "./layout"
import auth from './authentication'
import navbar from "./navbar"

const rootReducer = {
    auth,
    // todo,
    // chat,
    // email,
    // users,
    navbar,
    layout
    // invoice,
    // calendar,
    // ecommerce,
    // dataTables,
    // permissions
  }
  
export default rootReducer
